"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.envArraysShouldBeFlattenInTSV = void 0;
exports.envArraysShouldBeFlattenInTSV = ["array", "gathered", "aligned"];
//# sourceMappingURL=consts.js.map